import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AddToHomeScreenIcon(props: IconProps) {
    return <Icon {...props} iconKey={"add_to_home_screen"}/>
}
